import { createContext, useContext, useState, useEffect, useMemo } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const authAxios = useMemo(() => {
    const instance = axios.create({ baseURL: API, withCredentials: true });
    instance.interceptors.response.use(
      (res) => res,
      (err) => {
        if (err.response?.status === 401) setUser(null);
        return Promise.reject(err);
      }
    );
    return instance;
  }, []);

  useEffect(() => {
    // Restore session from httpOnly cookie
    authAxios.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = (userData) => setUser(userData);

  const logout = async () => {
    try { await authAxios.post("/auth/logout"); } catch {}
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated: !!user, loading, login, logout, authAxios }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
